import loadable from "@loadable/component";

export const IntegratedEmissionLabel = loadable(async () => {
    const component = await import(
        /* webpackChunkName: "integrated-emission-label" */
        /* webpackPreFetch: true */
        "./EmissionLabel"
    );
    return component.default;
});
